import { UserData, GraphUser } from '../types/userData';
import { parseBusinessPhone } from './phoneParser';

/**
 * Map Graph API user to template test data format
 */
export function mapUserToTestData(
  user: GraphUser,
  tenantName: string,
  profilePictureUrl: string
): UserData {
  const email = user.mail || user.userPrincipalName || user.email || '';
  
  return {
    profilePicture: profilePictureUrl,
    logo1: '',
    logo2: '',
    displayName: user.displayName || '',
    givenName: user.givenName || '',
    surname: user.surname || '',
    email: email,
    jobTitle: user.jobTitle || '',
    department: user.department || '',
    officeLocation: user.officeLocation || '',
    mobilePhone: user.mobilePhone || '',
    businessPhones: parseBusinessPhone(user.businessPhones),
    faxNumber: user.faxNumber || '',
    // Address fields
    streetAddress: user.streetAddress || '',
    city: user.city || '',
    state: user.state || '',
    postalCode: user.postalCode || '',
    country: user.country || '',
    // Company
    companyName: user.companyName || tenantName || '',
    companyDomain: user.tenant?.domain || '',
    // Employee fields
    employeeId: user.employeeId || '',
    employeeType: user.employeeType || '',
    employeeHireDate: user.employeeHireDate || '',
    // Preferences
    preferredLanguage: user.preferredLanguage || '',
    usageLocation: user.usageLocation || '',
    // Extension attributes
    extensionAttribute1: user.extensionAttribute1 || '',
    extensionAttribute2: user.extensionAttribute2 || '',
    extensionAttribute3: user.extensionAttribute3 || '',
    extensionAttribute4: user.extensionAttribute4 || '',
    extensionAttribute5: user.extensionAttribute5 || '',
    extensionAttribute6: user.extensionAttribute6 || '',
    extensionAttribute7: user.extensionAttribute7 || '',
    extensionAttribute8: user.extensionAttribute8 || '',
    extensionAttribute9: user.extensionAttribute9 || '',
    extensionAttribute10: user.extensionAttribute10 || '',
    extensionAttribute11: user.extensionAttribute11 || '',
    extensionAttribute12: user.extensionAttribute12 || '',
    extensionAttribute13: user.extensionAttribute13 || '',
    extensionAttribute14: user.extensionAttribute14 || '',
    extensionAttribute15: user.extensionAttribute15 || '',
  };
}

/**
 * Get dummy test user data for preview
 */
export function getDummyUserData(): UserData {
  return {
    profilePicture: 'https://ui-avatars.com/api/?name=John+Smith&size=80&background=0066cc&color=fff',
    logo1: '',
    logo2: '',
    displayName: 'John Smith',
    givenName: 'John',
    surname: 'Smith',
    email: 'john.smith@company.com',
    jobTitle: 'Senior Developer',
    department: 'IT Department',
    officeLocation: 'New York Office',
    mobilePhone: '+1 ************',
    businessPhones: '+1 ************',
    faxNumber: '',
    streetAddress: '',
    city: '',
    state: '',
    postalCode: '',
    country: '',
    companyName: 'ACME Corporation',
    companyDomain: 'company.com',
    employeeId: '',
    employeeType: '',
    employeeHireDate: '',
    preferredLanguage: '',
    usageLocation: '',
    extensionAttribute1: '',
    extensionAttribute2: '',
    extensionAttribute3: '',
    extensionAttribute4: '',
    extensionAttribute5: '',
    extensionAttribute6: '',
    extensionAttribute7: '',
    extensionAttribute8: '',
    extensionAttribute9: '',
    extensionAttribute10: '',
    extensionAttribute11: '',
    extensionAttribute12: '',
    extensionAttribute13: '',
    extensionAttribute14: '',
    extensionAttribute15: '',
    // Shared mailbox sample data for preview
    shared: {
      displayName: 'Invoice Department',
      email: 'invoice@company.com',
      jobTitle: 'Shared Mailbox',
      department: 'Finance',
      mobilePhone: '',
      businessPhone: '+1 (555) 000-0000',
      officeLocation: 'Main Office',
      companyName: 'ACME Corporation',
    },
  };
}
